module.exports = __webpack_public_path__ + "static/media/madisa-logo.de2d1236.png";